// extracted by mini-css-extract-plugin
module.exports = {"link":"AppStoreButton_link__YqfwA"};